

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const BULKUPLOADDEPARTMENTS= createAsyncThunk(
  "bulkUploadDepartments/bulkUploadDepartments",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const bulkUploadDepartmentsSlice = createSlice({
  name: "bulkUploadDepartmentsSlice",
  initialState: {
    bulkUploadDepartments: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfbulkUploadDepartments: (state) => {
        state.bulkUploadDepartments.loading = false
        state.bulkUploadDepartments.error = false
        state.bulkUploadDepartments.data = []
        state.bulkUploadDepartments.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(BULKUPLOADDEPARTMENTS.fulfilled, (state, action) => {
      state.bulkUploadDepartments = {
        ...state.bulkUploadDepartments,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(BULKUPLOADDEPARTMENTS.pending, (state, action) => {
      state.bulkUploadDepartments = {
        ...state.bulkUploadDepartments,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(BULKUPLOADDEPARTMENTS.rejected, (state, action) => {
      state.bulkUploadDepartments = {
        ...state.bulkUploadDepartments,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const bulkUploadDepartmentsAction = {
    BULKUPLOADDEPARTMENTS,
};

export { bulkUploadDepartmentsAction };
export default bulkUploadDepartmentsSlice.reducer;
export const {setInitialStateOfbulkUploadDepartments} = bulkUploadDepartmentsSlice.actions
